import Frame from "../../../assets/Frame1.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const Banner = ({ title }) => {
  const { t } = useTranslation();

  return (
    <div className="bannerHome no-race-banner" >
        <img src={Frame} alt="Saddle Battle Logo" className="no-race-logo" />
        <h1 className="no-race-text">{title ? t(title) : t("No_Race_Today")}</h1>
    </div>
  );
};
export default Banner;
